/**
 * 用户类型枚举
 */
export enum UserType {
    CLIENT = 1,
    TENANT = 2
}

/**
 * 来源页面枚举
 */
export enum SourceFrom {
    HOME = 'home',
    PORTAL = 'portal',
    PORTALNEW = 'portalnew'
}

/**
 * 控制塔路径枚举
 */
export enum ControlTowerPath {
    // 认证相关路径
    AUTH_TENANT = '/auth/tenant',
    AUTH_STAFF = '/auth/staff',
    AUTH_PORTAL = '/client/auth/portal',
    //首页
    HOME = '/home',
    // 个人中心
    PROFile = '/user-center/profile',
    // 企业信息
    COMPANY_PROFILE = '/user-center/company-profile',
    // 超级运价
    SASS = 'saas/rate-query?tab=fcl'
}
